import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { api } from '../../../services/api';
import { sortAlphabetical } from '../../../utils/utils';
import feedComparisonService from './feed-service';

import './merchant-dropdown.scss';

class MerchantDropdown extends Component {
  constructor(props) {
    super(props);

    this.Api = api;
    this.service = feedComparisonService;

    this.dropdownNode = null;

    this.state = {
      merchants: [],
      merchantList: [],
      opened: false,
      selectedMerchant: 'Select Merchant',
      searchTerm: '',
    };
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleClick.bind(this), false);
  }

  componentDidMount() {
    window.addEventListener('click', this.handleClick.bind(this), false);

    this.getMerchants();
  }

  handleClick(event) {
    if (this.dropdownNode && !this.dropdownNode.contains(event.target)) {
      this.dropdownNode.classList.remove('open');
    }
  }

  getMerchants() {
    this.service.queryMerchantInfo().then(({ merchants }) => {
      sortAlphabetical(merchants, 'full_name');
      this.setState({
        merchants,
        merchantList: merchants,
      });
    });
  }

  toggleDropdown() {
    this.setState({ opened: !this.state.opened });
  }

  handleSearchChange(event) {
    this.filterMerchantsByName(event.target.value);
  }

  filterMerchantsByName(searchTerm) {
    const merchants = this.state.merchants.filter(merchant => {
      const name = merchant.full_name || '';
      return name.toLowerCase().startsWith(searchTerm.toLowerCase());
    });
    this.setState({
      merchantList: merchants,
      searchTerm,
    });
  }

  loadFeedDifferenceCounts(item) {
    this.setState({
      selectedMerchant: item.full_name,
      opened: false,
    });
    this.props.history.push(`/v2/admin/feed-comparison/${item.merch_id}/`);
  }

  render() {
    return (
      <div
        ref={node => (this.dropdownNode = node)}
        className={`feed-differences-merchant-dropdown
				${this.state.opened ? 'open' : 'closed'}`}
      >
        <div className="dropdown-toggle" tabIndex={0} onClick={this.toggleDropdown.bind(this)}>
          <span>{this.state.selectedMerchant}</span>
          <span className="narrativ-icon down"></span>
        </div>
        <ul className="dropdown-menu">
          <li className="search-input">
            <span className="narrativ-icon search"></span>
            <input
              type="text"
              placeholder="Search"
              value={this.state.searchTerm}
              onChange={this.handleSearchChange.bind(this)}
            />
          </li>

          {this.state.merchantList.map((item, i) => {
            return (
              <li key={i} className="merchant" onClick={() => this.loadFeedDifferenceCounts(item)}>
                <Link to="">{item.full_name}</Link>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default withRouter(MerchantDropdown);
